import { DataCapsule } from './data-capsule';
import { CachedStorageStrategy } from './strategies/cached-storage';
import { InMemoryStorageStrategy } from './strategies/in-memory-storage';
import { LocalStorageStrategy, } from './strategies/local-storage';
export function LocalStorageCapsule(options) {
    return new DataCapsule({ ...options, strategy: new LocalStorageStrategy() });
}
export function InMemoryStorageCapsule(options) {
    return new DataCapsule({
        ...options,
        strategy: new InMemoryStorageStrategy(),
    });
}
export function LocalStorageCachedCapsule({ remoteStrategy, ...options }) {
    return new DataCapsule({
        ...options,
        strategy: new CachedStorageStrategy({
            remoteStrategy,
        }),
    });
}
//# sourceMappingURL=capsules.js.map